/* eslint-disable no-unused-expressions */
<template>
  <div v-if="isStaff">
    <v-row>
      <v-col
        cols=8
      >
        <v-card
          class="mx-auto"
          max-width="100%"
          outlined>
          <v-data-table
            v-model="selected"
            :single-select="singleSelect"
            :headers="headers"
            :items="sensorList"
            :items-per-page="5"
            item-key="id"
            show-select
            class="elevation-1">
          </v-data-table>
        </v-card>
      </v-col>
      <v-col
        cols=4>
        <v-date-picker
          class="mx-auto"
          v-model="rawDates"
          range
        ></v-date-picker>
      </v-col>
    </v-row>
    <v-card
      class="mx-auto"
      max-width="100%"
      outlined>
      <v-row
        cols="12">
        <v-data-table
          :headers="headers2"
          :items="csvData"
          :items-per-page="5"
          class="elevation-1">
        </v-data-table>
      </v-row>
    </v-card>
    <v-btn type="submit" color="primary" class="my-6" block tile x-large @click="fetchSensorReadings" v-if="showButton">
      GENERATE
    </v-btn>
    <v-alert type="error" v-if="loadingCSV">
      Generating CSV: {{ getDownloadedRows }} Rows Fetched
    </v-alert>
    <download-csv
      class="btn btn-default"
      :data="csvData"
      name="filename.csv"
      v-if="showDownload">
      <v-btn type="submit" color="secondary" class="my-6" block tile x-large>Download CSV</v-btn>
    </download-csv>
    <br>

    <div v-if="debugging">
      <v-card>
        <v-card-title>Debugging</v-card-title>
        <p>{{ this.completedSensors }} / {{ selected.length }}</p>
        <p>{{ dates }}</p>
        <!-- <p>CSV Dara: {{ csvData }} </p> -->
        <p>Selected: {{ selected }}</p>
        <!-- <p>Sensor List: {{ sensorList }}</p>
        <p>Building Info: {{ buildingInfo }}</p>
        <p>Sensor Readings: {{ sensorReadings }}</p> -->
      </v-card>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import JsonCSV from 'vue-json-csv'
import api from '../api'

// eslint-disable-next-line no-unused-vars
async function getData2 (id, epoch, token) {
  console.log(epoch)
  const url = `https://console.beringar.co.uk/api/beta/sensorreading/sensorlocation/${id}/after/${epoch}`
  const result = await fetch(url, {
    method: 'GET',
    withCredentials: true,
    headers: {
      'Authorization': `JWT ${token}`, 'Content-Type': 'application/json'
    }
  })
  const latestData = await result.json()
  return latestData
}

// eslint-disable-next-line no-extend-native
Date.prototype.getUnixTime = function () { return this.getTime() / 1000 | 0 }
if (!Date.now) Date.now = function () { return new Date() }
Date.time = function () { return Date.now().getUnixTime() }

export default {
  name: 'dataPage',
  components: {
    'downloadCsv': JsonCSV
  },
  computed: mapState({
    buildingInfo: function (state) {
      return state.building.selectedBuildingInfo
    },
    sensorReadings: function (state) {
      return state.building.selectedBuildingSensorReadings
    },
    sensorList: function (state) {
      var buildingData = this.buildingInfo
      var readings = this.sensorReadings
      var sIds = []
      if (!buildingData) {
        return sIds
      }
      if (!readings) {
        return sIds
      }
      buildingData.room_set.forEach(function (bdata, index2) {
        var curLocSet = bdata.sensorlocation_set
        curLocSet.forEach(function (set, index3) {
          let listItem = { id: set.id, sensorname: set.name, roomname: set.roomname, floornumber: bdata.floornumber }
          /* Disabed as minor bug in building.js for Phil to fix
          readings.forEach(function (rec, index) {
            if (rec.detail.sensorlocationid === sIds[sIds.length - 1].id) {
              sIds[sIds.length - 1].id = rec.detail.physicalsensorid
            }
           })
           */
          sIds.push(listItem)
        })
      })
      console.log('Computed method: sensorList - update complete')
      return sIds
    },
    showDevelopment: state => state.auth.isDevelopment,
    getJWT: function (state) {
      return state.auth.jwt
    },
    dateRangeText () {
      return this.dates.join(' ~ ')
    },
    getStartDate () {
      return this.dates[0]
    },
    getEndDate () {
      return this.dates[1]
    },
    getDownloadedRows () {
      return this.csvData.length
    },
    dates: function () {
      if (this.rawDates.length === 2) {
        if (this.rawDates[0] > this.rawDates[1]) {
          return [this.rawDates[1], this.rawDates[0]]
        }
      }
      return this.rawDates
    },
    isStaff: state => state.auth.isStaff
  }),
  methods: {
    getLData: function (theUnixTime, unixEndDate, id, roomname, floornumber) {
      this.loadingCSV = true
      let url = `/privateapi/sensorreading/sensorlocation/${id}/after/${theUnixTime}`
      api.get(url, { headers: { Authorization: `JWT ${this.getJWT}` } })
        .then((response) => {
          let data = response.data
          let newData = []
          let timestamps = []
          // eslint-disable-next-line no-unused-vars
          let readings = this.sensorReadings
          data.forEach(function (dt, index) {
            if ((dt.rxepochmillisec <= unixEndDate)) {
              console.log('go')
              timestamps.push(dt.rxepochmillisec)
              delete dt.rxepochmillisec
              delete dt.daydimension_id
              delete dt.timemindimension_id
              readings.forEach(function (rec, index) {
                if (rec.detail.sensorlocationid === dt.sensorlocationcurrent) {
                  dt.deviceid = rec.detail.physicalsensorid
                }
              })
              delete dt.sensorlocationcurrent
              dt.roomname = roomname
              dt.floornumber = floornumber
              dt.ateccid = dt.device.ateccid
              newData.push(dt)
              // newData.append({ text: 'roomname', value: 'roomname' })
            } else {
              console.log('after')
            }
          })
          if (newData.length !== 0) {
            this.csvData = this.csvData.concat(newData)
            console.log(this.csvData)
            theUnixTime = timestamps[timestamps.length - 1]
            if (theUnixTime <= unixEndDate) {
              console.log('yes')
              this.getLData(theUnixTime, unixEndDate, id)
            } else {
              console.log('no')
              this.completedSensors = this.completedSensors + 1
              console.log('increment')
              if (this.completedSensors === this.selected.length) {
                this.loadingCSV = false
                this.showButton = true
                this.showDownload = true
                this.completedSensors = 0
              }
            }
          } else {
            console.log('else')
            this.loadingCSV = false
          }
        })
        .catch((reason) => {
          console.log(reason)
          // TODO add flag that network offline and link to periodic reload
        })
    },
    fetchSensorReadings: function () { // PGC: was fetchSensorReadings
      var endDate, unixEndDate
      this.showButton = false
      this.showDownload = false
      this.csvData = []
      var someDate = new Date(this.getStartDate + ' 00:00:00 GMT')
      var theUnixTime = someDate.getUnixTime()
      theUnixTime = theUnixTime * 1000
      if (this.dates.length === 1) {
        endDate = new Date(this.getStartDate + ' 23:59:59 GMT')
        console.log(endDate)
        unixEndDate = endDate.getUnixTime()
        unixEndDate = unixEndDate * 1000
        console.log(unixEndDate)
        this.loadingCSV = true
      } else {
        endDate = new Date(this.getEndDate + ' 23:59:59 GMT')
        console.log(endDate)
        unixEndDate = endDate.getUnixTime()
        unixEndDate = unixEndDate * 1000
        console.log(unixEndDate)
        this.loadingCSV = true
      }
      var tempThis = this
      this.selected.forEach(function (sensor, index) {
        console.log('print')
        tempThis.getLData(theUnixTime, unixEndDate, sensor.id, sensor.roomname, sensor.floornumber)
      })
    }
  },
  mounted () {
    var today = new Date()
    var dd = String(today.getDate()).padStart(2, '0')
    var mm = String(today.getMonth() + 1).padStart(2, '0')
    var yyyy = today.getFullYear()
    today = yyyy + '-' + mm + '-' + dd
    console.log(today)
    this.dates.push(today)
  },
  watch: {
    selected (value) {
      if (value === []) {
        this.showButton = false
      } else {
        this.showButton = true
      }
    },
    csvData (value) {
      if (value === []) {
        this.showDownload = false
      } else {
        this.showDownload = true
      }
    },
    dates (value) {
      if (value === []) {
        this.showButtton = false
      } else {
        this.showButton = true
      }
    }
  },
  data: () => {
    // eslint-disable-next-line no-labels
    return {
      singleSelect: false,
      rawDates: [],
      selected: [],
      lData: [],
      csvData: [],
      IDs: null,
      loadingCSV: false,
      showButton: false,
      showDownload: false,
      completedSensors: 0,
      debugging: true,
      headers: [
        { text: 'ID', value: 'id' },
        { text: 'Sensor Name', value: 'sensorname' },
        { text: 'Room Name', value: 'roomname' },
        { text: 'Floor Number', value: 'floornumber' }],
      headers2: [
        { text: 'ateccid', value: 'ateccid' },
        { test: 'aqi', value: 'aqi' },
        { test: 'aqi2', value: 'aqi2' },
        { test: 'bearing', value: 'bearing' },
        { text: 'co2', value: 'co2' },
        { text: 'co2bme', value: 'co2bme' },
        { text: 'co2hq', value: 'co2hq' },
        { text: 'countin', value: 'countin' },
        { text: 'countout', value: 'countout' },
        { text: 'decodeversion', value: 'decodeversion' },
        { text: 'estimatedoccupancybycount', value: 'estimatedoccupancybycount' },
        { text: 'humid', value: 'humid' },
        { text: 'internalhumid', value: 'internalhumid' },
        { text: 'internaltemperature', value: 'internaltemperature' },
        { text: 'lowlight', value: 'lowlight' },
        { text: 'lux', value: 'lux' },
        { text: 'noise', value: 'noise' },
        { text: 'occupancy', value: 'occupancy' },
        { text: 'pressure', value: 'pressure' },
        { text: 'rawgasbme', value: 'rawgasbme' },
        { text: 'timestamp', value: 'rxtimestamputc' },
        { text: 'timestampmillisec', value: 'rxtimestampmillisec' },
        { text: 'sensorlocationcurrent', value: 'sensorlocationcurrent' },
        { text: 'temperature', value: 'temperature' },
        { text: 'voc', value: 'voc' },
        { text: 'xycount', value: 'xycount' },
        { text: 'deviceid', value: 'deviceid' },
        { text: 'Room Name', value: 'roomname' },
        { text: 'Floor Number', value: 'floornumber' }]
    }
  }
}
</script>
